import { useEffect, useState } from "react";
import { useT } from "../i18n/index.js";
import { navigate } from "../router.js";
import { GrowthView } from "./GrowthView.js";
import { AchievementsView } from "./AchievementsView.js";

export type ProgressSegment = "growth" | "achievements";

/** Growth chain and achievements under one Progress tab with a segmented control; deep links keep their own routes (D68). */
export function ProgressView({ initial }: { initial: ProgressSegment }) {
  const t = useT();
  const [seg, setSeg] = useState<ProgressSegment>(initial);
  useEffect(() => setSeg(initial), [initial]);
  const pick = (next: ProgressSegment) => {
    setSeg(next);
    navigate(`/app/events/${next}`);
  };
  return (
    <div className="progress-view" data-testid="progress-view">
      <div className="segmented" role="tablist">
        {(["growth", "achievements"] as const).map((s) => (
          <button key={s} type="button" role="tab" aria-selected={seg === s} className={`seg ${seg === s ? "active" : ""}`} onClick={() => pick(s)} data-testid={`progress-seg-${s}`}>
            {t(`events.tab.${s}`)}
          </button>
        ))}
      </div>
      {seg === "growth" ? <GrowthView /> : <AchievementsView />}
    </div>
  );
}
